var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/clock"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0001 18.9587C5.05841 18.9587 1.04175 14.942 1.04175 10.0003C1.04175 5.05866 5.05841 1.04199 10.0001 1.04199C14.9417 1.04199 18.9584 5.05866 18.9584 10.0003C18.9584 14.942 14.9417 18.9587 10.0001 18.9587ZM10.0001 2.29199C5.75008 2.29199 2.29175 5.75033 2.29175 10.0003C2.29175 14.2503 5.75008 17.7087 10.0001 17.7087C14.2501 17.7087 17.7084 14.2503 17.7084 10.0003C17.7084 5.75033 14.2501 2.29199 10.0001 2.29199Z",
    fill: "#949DA6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.0916 13.2755C12.9833 13.2755 12.875 13.2505 12.775 13.1838L10.1916 11.6421C9.54995 11.2588 9.07495 10.4171 9.07495 9.67546V6.25879C9.07495 5.91712 9.35828 5.63379 9.69995 5.63379C10.0416 5.63379 10.325 5.91712 10.325 6.25879V9.67546C10.325 9.97546 10.575 10.4171 10.8333 10.5671L13.4166 12.1088C13.7166 12.2838 13.8083 12.6671 13.6333 12.9671C13.5083 13.1671 13.3 13.2755 13.0916 13.2755Z",
    fill: "#949DA6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.4ca79ade444328fa49abb6f840f89995.svg";
export { ForwardRef as ReactComponent };